import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class AboutContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{},
            playingIndex: null,
            showModal: false,
            activeVideo: null
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
  <div class="about-area inc-video default-padding">
        <div class="container">
        <div class="row">
              
              <div class="about-content">
                  <div class="col-md-5">
                      <div class="thumb">
                          <img src={this.props.content[10].image} alt={this.props.content[10].title} className='cm-img' />  
                      </div>
                  </div>
                  <div class="col-md-7 info-content"> 
                      <h1><div  dangerouslySetInnerHTML={{ __html: this.props.content[10].title}} /></h1> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[10].description}} />  
                  </div>
              </div>
              
          </div>
          <div class="row">
              
              <div class="about-content"> 
                  <div class="col-md-12 info-content"> 
                    <br/> 
                      <h4><div  dangerouslySetInnerHTML={{ __html: this.props.content[15].title}} /></h4> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[15].description}} />  
                  </div>
              </div>
              
          </div>
          <div class="row">
              <br/> 
              <div class="about-content">
                 
                  <div class="col-md-6 info-content">
                      <h4>{this.props.content[12].title}</h4> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[12].description}} />  
                  </div>
                  <div class="col-md-6 info-content">
                      <h4>{this.props.content[14].title}</h4> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[14].description}} />  
                    </div> 
              </div>
              
          </div>
          <div class="row">
              <br/><br/>
              <div class="about-content">
                  
                    <div class="col-md-6 info-content">
                      <h4>{this.props.content[11].title}</h4> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[11].description}} />  
                  </div>
                  <div class="col-md-6 info-content">
                      <h4>{this.props.content[13].title}</h4> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[13].description}} />  
                    </div>
              </div>
              
          </div>
          
        </div>
    </div>
<div className='container'>
    <div className="row gutter-y-30 section-space-top section-space-bottom">

             
{
  this.props.awards.reduce((rows, award, index) => {
    if (index % 3 === 0) {
      rows.push([]);
    }
    rows[rows.length - 1].push(award);
    return rows;
  }, []).map((row, rowIndex) => (
    <div
      className="row gutter-y-30 section-space-top section-space-bottom"
      key={rowIndex}
    >
      {row.map((award, key) => (
        <div className="col-md-4 col-lg-4" key={key}>
          <div className="blog-card wow fadeInUp">
            <div className="blog-card__content">
              <div
                className="blog-card__image awards-img"
                style={{ position: "relative", cursor: "pointer" }}
              >
                <img src={award.image} alt={award.title} />

                {award.video && (
                  <div
                    onClick={() =>
                      this.setState({
                        showModal: true,
                        activeVideo: award.video
                      })
                    }
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      background: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      padding: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <span style={{ color: "#fff", fontSize: "24px" }}>▶</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ))
}

{this.state.showModal && (
  <div className="video-modal">
    <div className="video-modal-overlay"
      onClick={() => this.setState({ showModal: false, activeVideo: null })}
    ></div>

    <div className="video-modal-content">
      <span
        className="video-close"
        onClick={() => this.setState({ showModal: false, activeVideo: null })}
      >
        ×
      </span>

      <video width="100%" controls autoPlay>
        <source src={this.state.activeVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
)}


</div>


</div>
        <br />
        <br />
        </div>
       

    );
 
    }
}

export default AboutContent;